import { useAppSelector } from 'store/Store';
import { Navbar } from 'reactstrap';
import logo_onetimeoxy from 'assets/images/logos/logo_ontimeoxy.png';
import LanguagePicker from 'components/i18n/LanguagePicker';

const GuestHeader = () => {
  const isDarkMode = useAppSelector((state) => state.customizer.isDark);
  const topbarColor = useAppSelector((state) => state.customizer.topbarBg);

  return (
    <>
      <Navbar
        color={topbarColor}
        dark={!isDarkMode}
        light={isDarkMode}
        expand="lg"
        className="topbar"
      >
        <div className="d-flex w-100 align-items-center">
          <div className="d-flex justify-content-center flex-grow-1">
            <div className="d-inline-block" style={{ width: '256px' }}>
              <img src={logo_onetimeoxy} alt="OnetimeOxy" className="mw-100" />
            </div>
          </div>
          <div className="d-flex align-items-center" style={{ height: '48px' }}>
            <div style={{ width: '200px' }}>
              <LanguagePicker showLabel={false} />
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
};

export default GuestHeader;
